<template>
  <!-- 行业新闻 -->
  <div class="news">
    <div class="news-title">
      <div class="border-blod">
        <slot name="icon">
          <!-- 图标 -->
        </slot>
        <div class="title">{{ title }}</div>
      </div>
      <div
        :style="moreText ? 'display: block' : 'display: none'"
        class="more link"
        @click="$router.push('/moreInform')"
      >
        查看更多 >>
      </div>
    </div>
    <div class="news-content">
      <div class="news-item" v-for="news in newsList.data" :key="news.id">
        <div class="point"></div>
        <div class="news-item-content">
          <div
            class="news-item-title text-ellipsis-row link"
            @click="$emit('toDetail', news.id, news.content, news.url)"
          >
            {{ news.title }}
          </div>
          <div class="news-item-detail text-ellipsis-row">
            {{ news.title }}
          </div>
        </div>
      </div>
    </div>
    <div class="page" :style="pageShow ? 'display: block' : 'display: none;'">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="newsList.total"
        :page-size="9"
        :page="newsList.current_page"
        @current-change="currentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    newsList: {
      type: Object,
      default: () => { { } }
    },
    pageShow: { // 分页显示/隐藏
      type: Boolean,
      default: false
    },
    moreText: { // 查看更多显示/隐藏
      type: Boolean,
      default: false
    }
  },
  methods: {
    // 切换页码
    currentChange(page) {
      this.$emit('currentPage', page)
    },

  }
}
</script>

<style lang="less" scoped>
.news {
  margin-top: 50px;
  .news-title {
    display: flex;
    justify-content: space-between;
    position: relative;
    height: 35px;
    border-bottom: 1px solid #D1D1D1;
    .border-blod {
      position: relative;
      top: 1px;
      width: 137px;
      padding-right: 40px;
      display: flex;
      border-bottom: 2px solid #017575;
      img {
        width: 24px;
        height: 24px;
        margin-top: 3px;
      }
      .title {
        margin-left: 15px;
        font-size: 24px;
        font-weight: bold;
        color: #017575;
      }
    }
    .more {
      line-height: 36px;
      color: #999999;
      font-size: 18px;
    }
  }
  .news-content {
    display: flex;
    // justify-content: space-between;
    flex-wrap: wrap;
    .news-item {
      box-sizing: border-box;
      display: flex;
      width: 30%;
      margin-top: 50px;
      margin-right: 5%;
      &:nth-child(3n) {
        margin-right: 0;
      }
      .point {
        margin-top: 7px;
        width: 7px;
        height: 7px;
        background: #b3b3b3;
        border-radius: 50%;
      }
      .news-item-content {
        width: 334px;
        margin-left: 25px;
        .news-item-title {
          width: 100%;
          font-size: 18px;
          color: #000;
          &:hover {
            color: #017575;
          }
        }
        .news-item-detail {
          width: 100%;
          height: 38px;
          margin-top: 24px;
          font-size: 14px;
          color: #666;
        }
      }
    }
  }
  .page {
    text-align: center;
    margin-top: 40px;
  }
}
</style>